import React from "react";
import MessageView from "../UploadComponents/MessageView";

function DoneUploading() {
  return <MessageView message="YES! Track(s) successfully uploaded" />;
}

export default DoneUploading;
